import type { FC } from 'react';
import { useQuery } from 'react-query';
import { validateUser } from '../apis';
import { ILoginData } from '../types';

export const ValidateUserLoader: FC<IValidateUserLoaderProps> = (props) => {
  const queryRes = useQuery('validate-user', () => validateUser(), {
    retry: false,
    onSuccess(response) {
      if (!response.data) {
        return;
      }
    },
  });

  if (queryRes.isLoading || queryRes.isIdle) {
    return (
      <div
        style={{
          backgroundColor: '#000',
          width: '100vw',
          height: '100vh',
        }}
      ></div>
    );
  }

  const data = queryRes.data?.data ?? null;
  return props.render(data);
};

interface IValidateUserLoaderProps {
  render: (data: ILoginData | null) => JSX.Element | null;
}
